import type { IndexState } from "../api/types";

const LABELS: Record<IndexState, string> = {
  system_never_indexed: "Never indexed (system)",
  domain_never_indexed: "Never indexed (domain)",
  indexing: "Indexing…",
  stale: "Stale",
  partial: "Partial",
  ready: "Ready",
};

// Tone drives the badge's colour class in styles/theme.css. "pending" states are visually distinct
// from "ready" and from "attention" (stale/partial), because they mean something different: nothing
// has been searched yet, as opposed to something was searched and the result is imperfect.
const TONES: Record<IndexState, "pending" | "attention" | "ready"> = {
  system_never_indexed: "pending",
  domain_never_indexed: "pending",
  indexing: "pending",
  stale: "attention",
  partial: "attention",
  ready: "ready",
};

interface StatusBadgeProps {
  state: IndexState;
}

export function StatusBadge({ state }: StatusBadgeProps): JSX.Element {
  return <span className={`badge badge--${TONES[state]}`}>{LABELS[state]}</span>;
}
